
import { Component, mixins, namespace, Watch } from 'nuxt-property-decorator';
import { PageType, PageScope, PageDto } from 'fourwaves-shared';
import {
  DateCarousel,
  SessionCard,
  NoResults,
  SessionFilterBar,
  CalendarDateIcon,
  SessionIndexMixin,
} from 'fourwaves-shared/components';
import { NuxtError } from '@nuxt/types';
import PageHeader from '~/components/layout/PageHeader.vue';

const EventsModule = namespace('events');

@Component({
  components: {
    PageHeader,
    DateCarousel,
    SessionCard,
    NoResults,
    SessionFilterBar,
    CalendarDateIcon,
  },
  scrollToTop: true,
  validate({ store }) {
    const page = store.state.events.pages.find(({ type }: PageDto) => type === PageType.Schedule);
    if (page && page.scope === PageScope.Participants) {
      if (!store.$auth.loggedIn) {
        const error: NuxtError = new Error();
        error.statusCode = 401;
        throw error;
      } else if (!store.getters['events/isParticipant'] && !store.getters['events/isOrganizer']) {
        const error: NuxtError = new Error();
        error.statusCode = 403;
        throw error;
      }
    }
    return !!page;
  },
})
export default class SchedulePage extends mixins(SessionIndexMixin) {
  @EventsModule.State pages!: PageDto[];
  @EventsModule.Getter isLiveAppOpen!: boolean;

  @Watch('currentModel.searchTerm')
  async onSearchTermChange() {
    await this.searchSessions();
  }

  get schedulePage(): PageDto | undefined {
    return this.pages.find(({ type }) => type === PageType.Schedule);
  }

  get headerTitle(): string | null {
    if (!this.schedulePage) return null;

    return this.transl8(this.schedulePage.name);
  }

  get headerDescription(): string | null {
    if (!this.schedulePage) return null;

    return `${this.$t('schedule.time_zone_details')} ${this.currentEvent.timeZone} ${this.$moment().format('z')}.`;
  }

  public head() {
    return {
      title: this.schedulePage ? this.transl8(this.schedulePage.name) : '',
    };
  }
}
